import { createSelector } from 'reselect';
import { CallHistoryActions, GET_CALL_HISTORY_SUCCESS, SET_CALL_HISTORY_PARAMS } from './call-history.actions';
import { CallHistoryCall, CallHistorySearchParams, CallHistoryState } from './call-history-params.interface';

export const initialState: CallHistoryState = {
  total: null,
  calls: [{}],
  params: {
    sortBy: 'callTime',
    order: 'DESC',
    pager: {
      pageIndex: 0,
      pageSize: 10,
      previousPageIndex: 0
    }
  }
};

export function callHistoryReducer(
  state: CallHistoryState = initialState,
  action: CallHistoryActions
): CallHistoryState {
  switch (action.type) {
    case GET_CALL_HISTORY_SUCCESS:
      return {
        ...state,
        calls: action.payload.data,
        total: action.payload.total
      };
    case SET_CALL_HISTORY_PARAMS:
      return {
        ...state,
        params: action.payload
      };
    default: {
      return state;
    }
  }
}

export const getCallHistoryPage = (state): CallHistoryState => state.callHistory;
export const getCalls = (callHistoryState: CallHistoryState): CallHistoryCall[] => callHistoryState.calls;
export const getTotal = (callHistoryState: CallHistoryState): number => callHistoryState.total;
export const getParams = (callHistoryState: CallHistoryState): CallHistorySearchParams => callHistoryState.params;
export const getCallHistoryCallsSelector = createSelector(getCallHistoryPage, getCalls);
export const getCallHistoryTotalSelector = createSelector(getCallHistoryPage, getTotal);
export const getCallHistoryPageSelector = createSelector(getCallHistoryPage, getParams);
